import React from 'react';
import { Handle, Position } from 'reactflow';
import './DelayNode.css';

const DelayNode = ({ data, isConnectable, selected }) => {
    const getDelayDisplay = () => {
        const amount = data.delayAmount || 1;
        const type = data.delayType || 'hours';
        return `${amount} ${type}`;
    };

    return (
        <div className={`email-delay-node ${selected ? 'selected' : ''}`}>
            <Handle
                type="target"
                position={Position.Left}
                id="delay-input"
                isConnectable={isConnectable}
                className="email-handle email-handle-input"
            />

            <div className="email-node-header delay">
                <span className="email-node-icon">⏰</span>
                <span className="email-node-type">DELAY</span>
            </div>
            
            <div className="email-node-content">
                <h4>{data.label}</h4>
                <div className="email-delay-display">
                    <span className="delay-duration">{getDelayDisplay()}</span>
                </div>
                <p className="email-node-description">
                    Wait before continuing to next step
                </p>
            </div>

            <Handle
                type="source"
                position={Position.Right}
                id="delay-output"
                isConnectable={isConnectable}
                className="email-handle email-handle-output"
            />
        </div>
    );
};

export default DelayNode;
